import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=18bf8b4e&scoped=true&"
import script from "./js/button.js?vue&type=script&lang=js&"
export * from "./js/button.js?vue&type=script&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=18bf8b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf8b4e",
  null
  
)

export default component.exports